import { getAuthAxiosBackend } from "@/helpers/axios"

class BodySubPartsServices {

    getByGovernorateId(id) {
        return getAuthAxiosBackend().get('' + id.toString())
    }

    get(id) {
        return getAuthAxiosBackend().get('BodySubParts/getBodySubPartsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('BodySubParts/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('BodySubParts/addBodySubParts', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('BodySubParts/updateBodySubParts/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('BodySubParts/restoreBodySubParts' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('BodySubParts/softDeleteBodySubParts/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('BodySubParts/deleteBodySubParts/' + id.toString())
    }
}

export default new BodySubPartsServices()
